/**
 * @description 自定义reducer创建器
 * @author duanjun
 */

import type { AnyAction, IReducer, IState } from './interface';

interface ISource {
    [props: string]: any;
}

export interface IWrapperReducer extends IReducer {
    register: (reducer: IReducer) => void;
    destroy: (reducer: IReducer) => void;
}

class ReducerCreator {
    private reducerQueue: IReducer[];
    constructor(initReducer: IReducer) {
        initReducer =
            initReducer ||
            ((state) => {
                return state || {};
            });
        this.reducerQueue = [initReducer];
    }

    public register(reducer: IReducer) {
        const index = this.reducerQueue.indexOf(reducer);
        if (index < 0) {
            this.reducerQueue.push(reducer);
        }
    }

    public destroy(reducer: IReducer) {
        const index = this.reducerQueue.indexOf(reducer);
        if (index > -1) {
            this.reducerQueue.splice(index, 1);
        }
    }

    public getReducer() {
        return (state: IState | undefined, action: AnyAction) => {
            return this.reducerQueue.reduce((_state: IState | undefined, reducer) => {
                return reducer(_state, action);
            }, state);
        };
    }
}

function mixIn(target: ISource, source: ISource, props: string[] = []) {
    props.forEach((prop: string) => {
        source[prop] = source[prop].bind(source);
        target[prop] = (...args: any[]) => {
            source[prop].apply(source, args);
        };
    });
    return target;
}

function reducerFactory(initReducer: IReducer) {
    const creator = new ReducerCreator(initReducer);
    const reducerInstance = creator.getReducer();
    mixIn(reducerInstance, creator, ['register', 'destroy']);
    return reducerInstance;
}

export default reducerFactory;
